import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import { tint } from 'polished';

import colors from 'shared-assets/lib/colors';
import { H2 } from 'shared-assets/components/Elements';

const CardStyled = styled.section`
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  margin: 0;
  padding: 0;

  hr {
    margin: 1rem -1rem;
  }
`;

export const Title = styled.div`
  align-items: center;
  border-bottom: 1px solid ${tint(0.85, colors.secondary)};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0;
  padding: 0.5rem 1rem;

  button {
    align-items: center;
    background: none;
    border: none;
    display: flex;
    cursor: pointer;
    outline: none;

    span {
      display: flex;
    }

    svg {
      fill: ${colors.secondary};
      height: 0.75rem;
      width: 0.75rem;
    }
  }
`;

export const Footer = styled.div`
  border-top: 1px solid ${tint(0.85, colors.secondary)};
  margin: 0;
  padding: 1rem;
`;

export const Body = styled.div`
  padding: ${props => (!!props.fluid ? '0' : '1rem')};
  margin: 0;
`;

const Status = styled.span`
  color: ${colors.light};
  font-size: 0.875rem;
`;

const Card = props => (
  <CardStyled {...props}>
    <If condition={!!props.header}>
      <If condition={typeof props.header !== 'function'}>
        <Title>
          <H2>{props.header}</H2>
          <div>
            <If condition={props.status}>
              <Status>{props.status}</Status>
            </If>
            <If condition={typeof props.titleCta === 'function'}>
              {props.titleCta(props)}
            </If>
            <If
              condition={props.closeIcon || typeof props.onClose === 'function'}
            >
              <button aria-label="close" type="button" onClick={props.onClose}>
                <SVG src={require('shared-assets/assets/icons/close.svg')} />
              </button>
            </If>
          </div>
        </Title>
      </If>
      <If condition={typeof props.header === 'function'}>
        {props.header(props)}
      </If>
    </If>
    <If condition={!!props.children && typeof props.children === 'function'}>
      {props.children(props)}
    </If>
    <If condition={!!props.children && typeof props.children !== 'function'}>
      <Body fluid={props.fluid} style={props.bodyStyle}>
        {props.children}
      </Body>
    </If>
    <If condition={props.footer}>
      <If condition={typeof props.footer !== 'function'}>
        <Footer>{props.footer}</Footer>
      </If>
      <If condition={typeof props.footer === 'function'}>
        {props.footer(props)}
      </If>
    </If>
  </CardStyled>
);

Card.defaultProps = {
  children: undefined,
  fluid: undefined,
  footer: undefined,
  header: undefined,
  titleCta: undefined,
  onClose: undefined,
  status: undefined,
  bodyStyle: {},
  closeIcon: false,
};

Card.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  fluid: PropTypes.bool, // removes padding in body if true
  footer: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  header: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  titleCta: PropTypes.func,
  onClose: PropTypes.func,
  status: PropTypes.node,
  bodyStyle: PropTypes.object,
  closeIcon: PropTypes.bool,
};

export default Card;
